import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Grid,
  Typography,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
  Divider,
} from "@material-ui/core";

import { TextField } from "formik-material-ui";

import { Alert } from "@material-ui/lab";
import { Formik, Form, Field } from "formik";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import { getYear } from "src/redux/actions/year.action";

import DateFnsUtils from "@date-io/date-fns";
import { useSelector, useDispatch } from "react-redux";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import Moment from "moment";

import Swal from "sweetalert2";
import _ from "lodash";
import clsx from "clsx";
import { httpClient } from "src/utils/HttpClient";
import { apiUrl } from "src/Constants";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      // width: "26ch",
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "27ch",
  },
  inputDisabledForm: {
    margin: theme.spacing(1, 1, 1),
    width: "26ch",
    backgroundColor: "#D3D3D3",
    borderRadius: 4,
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const PurchaseRequestFormComponent = ({
  history,
  bindSubmitForm,
  initialValues = {
    PR_NO: "",
  },
  status,
  handleSubmitForm,
  year,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const {
    result: {
      email,
      companyid,
      countryid,
      company,
      country,
      currencyid,
      department,
      brand,
      department_id,
      brand_id,
      fullname,
    },
  } = useSelector((state) => state.loginReducer);

  const { years, purchaseRequest } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { allBrands, allDepartments } = useSelector(
    (state) => state.referenceReducer
  );

  const renderYear = () => {
    if (years.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return years.data.map((item) => (
      <MenuItem MenuItem={item.YEAR_CODE} value={item.YEAR_CODE}>
        {item.YEAR_CODE}
      </MenuItem>
    ));
  };

  const renderBrandName = (data) => {
    if (allBrands.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allBrands.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };
  const renderDepartmentName = (data) => {
    if (allDepartments.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allDepartments.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Fragment>
        <Formik
          key={`PurchaseHeadForm`}
          enableReinitialize
          initialValues={{
            ...initialValues,
            PR_TYPE: initialValues.PR_TYPE ? initialValues.PR_TYPE : 1,
            REF_PR_NO: initialValues.REF_PR_NO ? initialValues.REF_PR_NO : "",
            PR_VENDOR: initialValues.PR_VENDOR ? initialValues.PR_VENDOR : "",
            PR_COMPIDX_NAME: initialValues.PR_COMPIDX_NAME
              ? initialValues.PR_COMPIDX_NAME
              : company,
            PR_COUNTRYID_NAME: initialValues.PR_COUNTRYID_NAME
              ? initialValues.PR_COUNTRYID_NAME
              : country,
            PR_NO: initialValues.PR_NO ? initialValues.PR_NO : "",
            PR_BRANDID: initialValues.PR_BRANDID
              ? initialValues.PR_BRANDID
              : brand_id,
            PR_BRAND_NAME: initialValues.PR_BRANDID
              ? renderBrandName(initialValues.PR_BRANDID)
              : brand,
            PR_DEPARTID: initialValues.PR_DEPARTID
              ? initialValues.PR_DEPARTID
              : department_id,
            PR_DEPART_NAME: initialValues.PR_DEPARTID
              ? renderDepartmentName(initialValues.PR_DEPARTID)
              : department,
            PR_YEAR: initialValues.PR_YEAR ? initialValues.PR_YEAR : "",
            PR_STATUS: initialValues.PR_STATUS ? initialValues.PR_STATUS : "",
            POSTED_DATE: initialValues.POSTED_DATE
              ? Moment.utc(initialValues.POSTED_DATE)
                  .local("Asia/Bangkok")
                  .format("DD-MMM-YY")
              : "",
            POSTED_NAME: initialValues.POSTED_NAME
              ? initialValues.POSTED_NAME
              : fullname,
            POSTED_EMAIL: initialValues.POSTED_EMAIL
              ? initialValues.POSTED_EMAIL
              : email,
            PR_COMPIDX: companyid ? companyid : "",
            PR_CURRENCY: currencyid ? currencyid : "",
            REF_CODE_PR: "",
            CREATED_NAME: initialValues.CREATED_NAME
              ? initialValues.CREATED_NAME
              : "",
            TELEPHONE: initialValues.TELEPHONE ? initialValues.TELEPHONE : "",
            APPROVE_BY: initialValues.APPROVE_BY
              ? initialValues.APPROVE_BY
              : "",
            APPROVE_DATE: initialValues.APPROVE_DATE
              ? Moment.utc(initialValues.APPROVE_DATE)
                  .local("Asia/Bangkok")
                  .format("DD-MMM-YY")
              : "",
            REMARK: initialValues.REMARK ? initialValues.REMARK : "",
            REMARK_JOB: initialValues.REMARK_JOB
              ? initialValues.REMARK_JOB
              : "",
            SHOW_CREATED_DATE: initialValues.CREATED_DATE
              ? Moment.utc(initialValues.CREATED_DATE)
                  .local("Asia/Bangkok")
                  .format("DD-MMM-YY")
              : "",
            ASSIGN_DATE_SHOW: initialValues.ASSIGN_DATE
              ? Moment.utc(initialValues.ASSIGN_DATE)
                  .local("Asia/Bangkok")
                  .format("DD-MMM-YY")
              : "",
            REQUIRE_CONTRACT: initialValues.REQUIRE_CONTRACT
              ? initialValues.REQUIRE_CONTRACT
              : 0,
          }}
          validate={(values) => {
            const errors = {};

            if (!values.PR_YEAR) {
              errors.PR_YEAR = "Required";
            }

            if (!values.PR_YEAR) {
              errors.PR_YEAR = "Required";
            }

            if (values.PR_TYPE === 2 && !values.REF_PR_NO) {
              errors.REF_PR_NO = "Required";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              if (values.PR_TYPE === 2 && !purchaseRequest.data.REF_PR_NO) {
                httpClient
                  .get(
                    `${apiUrl}/purchase-request/find-detail-refcode/${values.PRHIDX}/${countryid}/${currencyid}/${values.REF_PR_NO}`
                  )
                  .then((result) => {
                    if (result.data) {
                      const { icon, data, message } = result.data;

                      if (icon === "success") {
                        values.REF_PR_NO = data.PR_NO;
                        handleSubmitForm(values);
                      } else if (icon === "warning") {
                        Swal.fire({
                          text: message,
                          icon: icon,
                        });
                      }
                    }
                  })
                  .catch((err) => {
                    Swal.fire({
                      text: err.message,
                      icon: "error",
                    });
                  });
              } else {
                handleSubmitForm(values);
              }

              setSubmitting(false);
            }, 500);
          }}
        >
          {(formikProps) => {
            const { handleSubmit, setFieldValue, values, errors, touched } =
              formikProps;

            bindSubmitForm(formikProps.submitForm);

            return (
              <Form noValidate onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Box display="flex" component="div" flexGrow={1} flex={1}>
                      <Alert
                        icon={false}
                        variant="filled"
                        severity="info"
                        style={{ width: "100%" }}
                      >
                        <Typography component="h2">
                          Purchase Requisition information
                        </Typography>
                      </Alert>
                    </Box>
                    <Box
                      display="flex"
                      component="div"
                      flexGrow={1}
                      flex={1}
                      flexDirection="row"
                      flexWrap="wrap"
                    >
                      <Box display="flex" flexDirection="column">
                        <Box>
                          <FormControl
                            className={clsx(classes.inputForm, {
                              [classes.inputDisabledForm]: Boolean(
                                values.PR_STATUS >= 10
                              ),
                            })}
                          >
                            <InputLabel id="select-status-label">
                              Document Status
                            </InputLabel>
                            <Field
                              component={CustomSelectInput}
                              name="PR_TYPE"
                              label="Document Status"
                              labelId="select-status-label"
                              onChange={(e) => {
                                e.preventDefault();
                                setFieldValue("REF_PR_NO", "");
                              }}
                              readOnly={Boolean(values.PR_STATUS >= 10)}
                            >
                              <MenuItem value={1}>New PR</MenuItem>
                              <MenuItem value={2}>Refered PR</MenuItem>
                            </Field>
                          </FormControl>
                        </Box>
                        <Box>
                          <Field
                            component={TextField}
                            name="REF_PR_NO"
                            label="Reference PR NO."
                            className={clsx(classes.inputForm, {
                              [classes.inputDisabledForm]: Boolean(
                                values.PR_STATUS >= 10
                              ),
                            })}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: Boolean(
                                values.PR_STATUS >= 10 || values.PR_TYPE === 1
                              ),
                            }}
                            error={Boolean(
                              errors.REF_PR_NO &&
                                touched.REF_PR_NO &&
                                errors.REF_PR_NO
                            )}
                          />
                        </Box>
                      </Box>
                      <Box display="flex" flexDirection="column">
                        <Box>
                          <FormControl
                            className={clsx(classes.inputForm, {
                              [classes.inputDisabledForm]: Boolean(
                                values.PR_STATUS >= 10
                              ),
                            })}
                          >
                            <InputLabel id="select-type-label">Type</InputLabel>
                            <Field
                              component={CustomSelectInput}
                              name="PR_VENDOR"
                              label="Type"
                              labelId="select-type-label"
                              onChange={(e) => {
                                e.preventDefault();
                              }}
                              readOnly={Boolean(values.PR_STATUS >= 10)}
                            >
                              <MenuItem value={10} selected>
                                PREFER VENDOR
                              </MenuItem>
                              <MenuItem value={20}>COMPARE PRICE</MenuItem>
                              <MenuItem value={30}>BIDDING</MenuItem>
                            </Field>
                          </FormControl>
                        </Box>
                        <Box>
                          <Field
                            component={TextField}
                            fullWidth
                            name="PR_COMPIDX_NAME"
                            label="Company"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Box>
                      </Box>
                      <Box display="flex" flexDirection="row" flexWrap="wrap">
                        <Box>
                          <Field
                            component={TextField}
                            name="PR_COUNTRYID_NAME"
                            label="Country"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Box>
                        <Box>
                          <FormControl
                            className={clsx(classes.inputForm, {
                              [classes.inputDisabledForm]: Boolean(
                                values.PR_STATUS >= 10
                              ),
                            })}
                          >
                            <InputLabel
                              error={Boolean(
                                errors.PR_YEAR &&
                                  touched.PR_YEAR &&
                                  errors.PR_YEAR
                              )}
                              id="select-year-label"
                            >
                              Budget Year
                            </InputLabel>
                            <Field
                              component={CustomSelectInput}
                              name="PR_YEAR"
                              label="Year"
                              labelId="select-year-label"
                              error={Boolean(
                                errors.PR_YEAR &&
                                  touched.PR_YEAR &&
                                  errors.PR_YEAR
                              )}
                              onChange={(e) => {
                                e.preventDefault();
                                dispatch(
                                  getYear(
                                    countryid +
                                      companyid +
                                      values.PR_BRANDID +
                                      e.target.value
                                  )
                                );
                              }}
                              readOnly={Boolean(values.PR_STATUS >= 10)}
                            >
                              {renderYear()}
                            </Field>
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display="flex" flexDirection="row" flexWrap="wrap">
                        <Box>
                          <Field
                            component={TextField}
                            name="PR_NO"
                            label="PR NO."
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Box>
                        <Box>
                          <Field
                            component={TextField}
                            name="PR_STATUS"
                            label="Status"
                            select
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                          >
                            <MenuItem value={5}>New PR</MenuItem>
                            <MenuItem value={10}>DRAFT</MenuItem>
                            <MenuItem value={20}>POST</MenuItem>
                            <MenuItem value={22}>Reviewed</MenuItem>
                            <MenuItem value={24}>Rejected By Reviewer</MenuItem>
                            <MenuItem value={26}>Held By Reviewer</MenuItem>
                            <MenuItem value={30}>APPROVED</MenuItem>
                            <MenuItem value={35}>HELD BY APPROVER</MenuItem>
                            <MenuItem value={40}>REJECTED BY APPROVER</MenuItem>
                            <MenuItem value={49}>CONTRACT IS REQUIRED</MenuItem>
                            <MenuItem value={50}>
                              PURCHASING IN PROGRESS
                            </MenuItem>
                            <MenuItem value={51}>VERIFIED PR</MenuItem>
                            <MenuItem value={52}>
                              LEGAL MAKES A DECISION
                            </MenuItem>
                            <MenuItem value={53}>
                              CONTRACT IS NOT REQUIRED
                            </MenuItem>
                            <MenuItem value={54}>LEGAL IN PROGRESS</MenuItem>
                            <MenuItem value={55}>
                              FINAL DRAFT IS DONE AND READY TO SIGN OFF
                            </MenuItem>
                            <MenuItem value={56}>CONTRACT IS ATTACHED</MenuItem>
                            <MenuItem value={57}>
                              LEGAL TASK IS COMPLETED
                            </MenuItem>
                            <MenuItem value={58}>CONTRACT IS REJECTED</MenuItem>
                            <MenuItem value={59}>HELD BY LEGAL</MenuItem>
                            <MenuItem value={60}>PURCHASING COMPLETED</MenuItem>
                            <MenuItem value={70}>PURCHASING HOLD</MenuItem>
                            <MenuItem value={80}>PURCHASING REJECTED</MenuItem>
                          </Field>
                        </Box>
                      </Box>
                      <Box display="flex" flexDirection="row" flexWrap="wrap">
                        <Box>
                          <Field
                            component={TextField}
                            name="SHOW_CREATED_DATE"
                            label="Request Date"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Box>
                        <Box>
                          <Field
                            component={TextField}
                            name="REQUIRE_CONTRACT"
                            label="Contract"
                            select
                            className={clsx({
                              [classes.inputDisabledForm]: Boolean(
                                values.PR_STATUS > 10
                              ),
                            })}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: Boolean(values.PR_STATUS > 10),
                            }}
                          >
                            <MenuItem value={0}>No</MenuItem>
                            <MenuItem value={1}>Yes</MenuItem>
                          </Field>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      display="flex"
                      component="div"
                      flexGrow={1}
                      flex={1}
                      flexDirection="column"
                    >
                      <Box flexGrow={1}>
                        <Box
                          display="flex"
                          component="div"
                          flexGrow={1}
                          flex={1}
                        >
                          <Alert
                            icon={false}
                            variant="filled"
                            severity="info"
                            style={{ width: "100%" }}
                          >
                            <Typography component="h2">
                              User request profile
                            </Typography>
                          </Alert>
                        </Box>
                        <div>
                          <Field
                            component={TextField}
                            name="CREATED_NAME"
                            label="Requester"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="CREATED_EMAIL"
                            label="E-mail"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </div>
                        <Divider />
                        <div>
                          <Field
                            component={TextField}
                            name="POSTED_NAME"
                            label="Post By"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="POSTED_EMAIL"
                            label="E-mail (Post By)"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </div>
                        <div>
                          <Field
                            component={TextField}
                            name="PR_BRAND_NAME"
                            label="Brand"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="PR_DEPART_NAME"
                            label="Department"
                            className={classes.inputDisabledForm}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </div>
                      </Box>
                      {purchaseRequest.data &&
                        purchaseRequest.data.PR_STATUS > 40 && (
                          <Box flexGrow={1}>
                            <Box
                              display="flex"
                              component="div"
                              flexGrow={1}
                              flex={1}
                            >
                              <Alert
                                icon={false}
                                variant="filled"
                                severity="info"
                                style={{ width: "100%" }}
                              >
                                <Typography component="h2">
                                  Purchasing Staff
                                </Typography>
                              </Alert>
                            </Box>
                            <div>
                              <Field
                                component={TextField}
                                name="ASSIGN_PURCHASE_NAME"
                                label="Assignee"
                                className={classes.inputDisabledForm}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                              <Field
                                component={TextField}
                                name="ASSIGN_DATE_SHOW"
                                label="Assigned Date"
                                className={classes.inputDisabledForm}
                                value={Moment(values.ASSIGN_DATE_SHOW).format(
                                  "DD-MMM-YY"
                                )}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </div>
                          </Box>
                        )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Box display="flex" flex={1} p={2}>
                      <Field
                        component={TextField}
                        name="REMARK"
                        label="Remark"
                        multiline
                        style={{
                          width: "100%",
                        }}
                        rows={4}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={clsx(classes.inputForm, {
                          [classes.inputDisabledForm]: Boolean(
                            values.PR_STATUS >= 20
                          ),
                        })}
                        InputProps={{
                          readOnly: Boolean(values.PR_STATUS >= 20),
                        }}
                        variant="outlined"
                      />
                    </Box>
                  </Grid>
                  {values.REMARK_JOB && (
                    <Grid item xs={12} sm={12}>
                      <Box display="flex" component="div" flexGrow={1} flex={1}>
                        <Alert
                          icon={false}
                          variant="filled"
                          severity="info"
                          style={{ width: "100%" }}
                        >
                          <Typography component="h2">
                            Purchasing staff
                          </Typography>
                        </Alert>
                      </Box>
                      <Box display="flex" flex={1} p={2}>
                        <Field
                          component={TextField}
                          name="REMARK_JOB"
                          label="Remark By Purchase Staff"
                          multiline
                          style={{
                            width: "100%",
                          }}
                          rows={4}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Fragment>
    </MuiPickersUtilsProvider>
  );
};

export default PurchaseRequestFormComponent;
